export default function Advantages() {
  const advantages = [
    {
      icon: 'ri-user-star-line',
      title: 'Partenaire des Professionnels',
      description: 'Architectes, maîtres d\'ouvrage et promoteurs nous font confiance pour leurs projets les plus exigeants à Genève et en Suisse romande.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Documentation Claire',
      description: 'Plans as-built détaillés, schémas techniques précis, certificats de conformité OIBT et manuels d\'utilisation complets pour faciliter la gestion de vos installations.'
    },
    {
      icon: 'ri-time-line',
      title: 'Réactivité Exceptionnelle',
      description: 'Service d\'intervention rapide 24/7, équipes disponibles et mobilisables rapidement pour tous vos besoins urgents ou planifiés.'
    },
    {
      icon: 'ri-award-line',
      title: 'Qualité Certifiée',
      description: 'Certifications professionnelles à jour, respect strict des normes OIBT/NIBT, contrôles qualité systématiques et garanties étendues sur nos prestations.'
    },
    {
      icon: 'ri-team-line',
      title: 'Équipe Expérimentée',
      description: 'Électriciens diplômés avec plus de 19 ans d\'expérience, formation continue et expertise reconnue dans les installations haut de gamme.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Tarification Transparente',
      description: 'Devis détaillés et transparents, pas de frais cachés, respect du budget convenu et optimisation du rapport qualité-prix pour chaque projet.'
    }
  ];

  return (
    <section id="avantages" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-teal-600">Nos Avantages</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Pourquoi Nous Choisir ?
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Des avantages concrets qui font la différence pour vos projets CVSE à Genève.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 hover:shadow-xl hover:border-teal-200 transition-all">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl mb-6 shadow-md">
                <i className={`${advantage.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{advantage.title}</h3>
              <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Zone d'Intervention</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-map-pin-fill text-teal-600 text-xl mt-1 mr-3"></i>
                <div>
                  <strong className="text-gray-900">Genève et Région</strong>
                  <p className="text-gray-600 mt-1">Intervention principale sur le canton de Genève et communes limitrophes</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-fill text-teal-600 text-xl mt-1 mr-3"></i>
                <div>
                  <strong className="text-gray-900">Suisse Romande</strong>
                  <p className="text-gray-600 mt-1">Projets d'envergure dans toute la Suisse romande (Vaud, Valais, Fribourg)</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Secteurs d'Activité</h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-center">
                <i className="ri-home-4-line text-teal-600 text-xl mr-2"></i>
                <span className="text-gray-700">Résidentiel haut de gamme</span>
              </div>
              <div className="flex items-center">
                <i className="ri-building-line text-teal-600 text-xl mr-2"></i>
                <span className="text-gray-700">Immeubles de standing</span>
              </div>
              <div className="flex items-center">
                <i className="ri-briefcase-line text-teal-600 text-xl mr-2"></i>
                <span className="text-gray-700">Bureaux et commerces</span>
              </div>
              <div className="flex items-center">
                <i className="ri-hotel-line text-teal-600 text-xl mr-2"></i>
                <span className="text-gray-700">Hôtellerie de luxe</span>
              </div>
              <div className="flex items-center">
                <i className="ri-hospital-line text-teal-600 text-xl mr-2"></i>
                <span className="text-gray-700">Établissements de santé</span>
              </div>
              <div className="flex items-center">
                <i className="ri-community-line text-teal-600 text-xl mr-2"></i>
                <span className="text-gray-700">Bâtiments publics</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
